module.exports = __webpack_public_path__ + "static/img/i1.91d48023.svg";